import React, { useEffect, useState } from "react";
import LdapForm from "../LdapForm/LdapForm";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShieldKeyhole } from '@fortawesome/pro-light-svg-icons/faShieldKeyhole';
import PageHeader, { parentRoutes } from "../../../components/Header/PageHeader";
import { Form, FormField, Groups, notifyFailure, notifySuccess } from "../../../components/Form"
import { updateLdap, get_ad_user_management_configs, create_ad_user_management_configs, update_ad_user_management_configs, delete_ad_user_management_configs } from "../../../actions/actionLdap";
import { getOidcConfigs } from "../../../actions/actionOidc.js"
import { get_saml_configs } from "../../../actions/actionSaml";
import MappingTable from "../../../components/MappingTable/";
import { t } from "i18next";
import { connect, useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import DataTable from "../../../components/Table/Table";
import { faListCheck } from "@fortawesome/pro-light-svg-icons/faListCheck";
import { Modal, ModalFooter } from "../../../components/Form/Modal";
import SelectCompat from "../../../components/SelectInput/SelectCompat";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderField, renderToggle } from "../../../utils/formValidations";
import { ConfirmAction, SettingColumn } from "../../../components/Table/NewTable";
import { faTrash } from "@fortawesome/pro-light-svg-icons/faTrash";

const parentRouteList = parentRoutes('/ldap')
const newRoutes = [
    ...parentRouteList.routes,
    { name: "generic.update", path: "/updateldap", isActive: true },
];

function AdSync(props) {
    const dispatch = useDispatch()
    const { hasCreateUser, hasManagePassword, ad_user_mgmt_config_id } = props;
    const ad_user_management_configs = useSelector(state => state.ldap_configs.ad_user_management_configs) || []
    const oidc_configs = useSelector(state => state.oidc.oidc_configs) || []
    const saml_configs = useSelector(state => state.saml.saml_configs) || []

    const [modal, setModal] = useState(false);
    const [type, setType] = useState('local');
    const [edit, setEdit] = useState(false);
    const [oidc, setOidc] = useState(null);
    const [saml, setSaml] = useState(null);
    const [current, setCurrent] = useState(null);
    const [confirmModal, setConfirmModal] = useState(false);
    
    useEffect(() => {
        dispatch(get_ad_user_management_configs({ ldap_id: props.match.params.id }))
    }, []);

    useEffect(() => {
        props.change('saml_id', saml)
    }, [saml]);

    useEffect(() => {
        props.change('oidc_id', oidc)
    }, [oidc]);

    const columns = [
        {
            type: "text",
            accessor: "ad_user_mgmt_config_id",
            name: t("auth.config"),
            colSize: 'minmax(130px, 1.2fr)'
        },
        {
            accessor: "oidc_id",
            name: t("auth.oidc_id"),
            overwrite: true,
            cell: (data) => <SettingColumn key={'oidc_id-' + data.original?.ad_user_mgmt_config_id} main={String(data.value) !== 'null' ? true : 'false'} sub={data.colName} />
        },
        {
            accessor: "saml_id",
            name: t("auth.saml_id"),
            overwrite: true,
            cell: (data) => <SettingColumn key={'saml_id-' + data.original?.ad_user_mgmt_config_id} main={String(data.value) !== 'null' ? true : 'false'} sub={data.colName} />
        },
        {
            accessor: "local_accounts",
            name: t("auth.local_accounts"),
            overwrite: true,
            cell: (data) => <SettingColumn key={'local_accounts-' + data.original?.ad_user_mgmt_config_id} main={String(data.value) !== 'false' ? true : 'false'} sub={data.colName} />
        },
        {
            type: "text",
            accessor: "ldap_id",
            name: t("auth.ldap_id"),
            showByDefault: false
        },

    ];
    const actions = [
        { id: "edit", icon: "fa-pencil", description: t("buttons.Edit") },
        { id: "delete", icon: "fa-trash", description: t("buttons.Delete") },
    ];

    const newModal = () => {
        setType('local')
        props.autofill('ad_user_mgmt_config_id', undefined)
        props.change('enable_ad_group_management', false)
        props.change('enable_create_user', false)
        props.change('enable_random_password_on_login', false)
        props.change('ldap_id', props.match.params.id)
        props.change('local_accounts', true)
        props.change('oidc_id', null)
        props.change('password_len', null)
        props.change('saml_id', null)
        props.change('user_container_dn', null)
        setModal(true)
    }

    const onAction = async (action, item) => {
        switch (action) {
            case "edit":
                if (item.oidc_id) {
                    setType('oidc')
                    dispatch(getOidcConfigs())
                    setOidc(item.oidc_id)
                }
                if (item.saml_id) {
                    setType('saml')
                    dispatch(get_saml_configs())
                    setSaml(item.saml_id)
                }
                if (item.local_accounts) {
                    setType('local')
                }
                props.change('ad_user_mgmt_config_id', item.ad_user_mgmt_config_id)
                props.change('enable_ad_group_management', item.enable_ad_group_management)
                props.change('enable_create_user', item.enable_create_user)
                props.change('enable_random_password_on_login', item.enable_random_password_on_login)
                props.change('ldap_id', item.ldap_id)
                props.change('local_accounts', item.local_accounts)
                props.change('oidc_id', item.oidc_id)
                props.change('password_len', item.password_len)
                props.change('saml_id', item.saml_id)
                props.change('user_container_dn', item.user_container_dn)
                setModal(true)
                break;

            case "delete":
                deleteConfirm(item)
                break;
            case "deleteMulti":
                const promises = []
                item.forEach(id => {
                  const promise = deleteConfig(id)
                  promises.push(promise)
                })
                await Promise.all(promises)
                dispatch(get_ad_user_management_configs({ ldap_id: props.match.params.id }))
        
                break;

        }
    }

    const addSync = async (userData) => {
        try {
            if (ad_user_mgmt_config_id) { //Update
                const { response: { error_message: errorMessage } } = await dispatch(update_ad_user_management_configs({ ad_user_management_config: userData }))
                notifySuccess({ errorMessage, type: 'update' })
            } else {
                const { response: { error_message: errorMessage } } = await dispatch(create_ad_user_management_configs({ ad_user_management_config: userData }))
                notifySuccess({ errorMessage, type: 'create' })
            }
        } catch (error) {
            notifyFailure({ error, type })
        }
        await dispatch(get_ad_user_management_configs({ ldap_id: props.match.params.id }))
        setModal(false)
    }

    const changeType = (val) => {
        if (val.value === 'oidc') {
            dispatch(getOidcConfigs())
            props.change('local_accounts', false)
        }
        if (val.value === 'saml') {
            dispatch(get_saml_configs())
            props.change('local_accounts', false)
        }
        if (val.value === 'local') {
            props.change('local_accounts', true)
        }
        props.change('oidc_id', null)
        props.change('saml_id', null)
        setOidc(null)
        setSaml(null)

        setType(val.value)
    }

    const changeOidcConfig = (val) => {
        setOidc(val.value)
    }
    const changeSamlConfig = (val) => {
        setSaml(val.value)
    }

    const optTypes = [
        { label: 'local', value: 'local' },
        { label: 'oidc', value: 'oidc' },
        { label: 'saml', value: 'saml' },
    ]

    let oidcOptions = [];
    oidc_configs.map(opt => {
        oidcOptions.push({ label: opt.display_name, value: opt.oidc_id });
    });

    let samlOptions = [];
    saml_configs.map(opt => {
        samlOptions.push({ label: opt.display_name, value: opt.saml_id });
    });

    const typeHelp = () => {
        if (type === 'local') {
            return 'kb-18-13'
        }
        if (type === 'oidc') {
            return 'kb-18-12'
        }
        if (type === 'saml') {
            return 'kb-18-11'
        }
    }

    const deleteConfirm = (item) => {
        setCurrent(item)
        setConfirmModal(true)
    }


    const deleteConfig = async (item) => {

        let id = null
        if (item) {
            id = item
        } else {
            id = current.ad_user_mgmt_config_id
        }

        try {
            const { response: { error_message: errorMessage } } = await dispatch(delete_ad_user_management_configs({
                ad_user_mgmt_config_id: id
            }));
            notifySuccess({ errorMessage, type: 'delete' })
            dispatch(get_ad_user_management_configs({ ldap_id: props.match.params.id }))
        } catch (error) {
            notifyFailure({ error, type: 'delete' })
        }

        setConfirmModal(false)
    }


    return (
        <React.Fragment>
            <p className="tw-bg-slate-500 dark:tw-bg-sky-900 tw-text-white tw-p-4 tw-rounded">
                {t('auth.ad-sync-description')}
            </p>
            <DataTable
                id="ldap-ad-sync"
                data={ad_user_management_configs}
                columns={columns}
                actions={actions}
                onAction={onAction}
                mainId="ad_user_mgmt_config_id"
                add={{
                    name: t("buttons.Add"),
                    onClick: newModal
                }}
            />
            <ConfirmAction
                confirmationDetails={{
                    action: null,
                    details: {
                    title: t('mapping.Attribute Mapping'),
                    text: t('mapping.confirm_delete'),
                    iconBg: 'tw-bg-pink-700 tw-text-white',
                    icon: <FontAwesomeIcon icon={faTrash} />,
                    confirmBg: 'tw-bg-pink-700',
                    confirmText: t('buttons.Delete'),

                    }
                }}
                open={confirmModal}
                setOpen={(value) => setConfirmModal(value)}
                onAction={deleteConfig}
            />

            <Modal
                icon={<FontAwesomeIcon icon={faListCheck} />}
                iconBg="tw-bg-blue-500 tw-text-white"
                title="auth.ad-sync"
                contentRaw={
                    <Groups className="tw-text-left tw-mt-8" noPadding section="auth" onSubmit={props.handleSubmit(addSync)}>
                        <FormField label="type">
                            <SelectCompat
                                id="state-select"
                                autoFocus
                                value={type}
                                options={optTypes}
                                name="userField"
                                onChange={changeType}
                                help={typeHelp()}
                            />
                        </FormField>
                        {type === 'oidc' &&
                            <FormField label="oidc_id">
                                <SelectCompat
                                    id="oidc-select"
                                    autoFocus
                                    value={oidc}
                                    options={oidcOptions}
                                    name="oidc_id"
                                    required={true}
                                    onChange={changeOidcConfig}
                                />
                            </FormField>
                        }
                        {type === 'saml' &&
                            <FormField label="saml_id">
                                <SelectCompat
                                    id="saml-select"
                                    autoFocus
                                    value={saml}
                                    options={samlOptions}
                                    name="saml_id"
                                    required={true}
                                    onChange={changeSamlConfig}
                                />
                            </FormField>
                        }
                        <Field type="text"
                            name="enable_random_password_on_login"
                            id="enable_random_password_on_login"
                            help="kb-18-14"
                            component={renderToggle}
                        />
                        <Field type="text"
                            name="enable_create_user"
                            id="enable_create_user"
                            help="kb-18-15"
                            component={renderToggle}
                        />
                        <Field type="text"
                            name="enable_ad_group_management"
                            id="enable_ad_group_management"
                            help="kb-18-16"
                            component={renderToggle}
                        />
                        {(hasCreateUser || hasManagePassword) &&
                        <Field type="text"
                            name="password_len"
                            id="password_len"
                            help="kb-18-17"
                            component={renderField}
                        />
                        }
                        {hasCreateUser &&
                            <Field type="text"
                                name="user_container_dn"
                                id="user_container_dn"
                                required={true}
                                help="kb-18-18"
                                component={renderField}
                            />
                        }

                        <ModalFooter cancel={() => setModal(false)} saveName={(edit) ? "buttons.Update" : "buttons.Add"} />
                    </Groups>
                }
                open={modal}
                setOpen={setModal}

            />

        </React.Fragment>
    )
}

AdSync = reduxForm({
    form: 'AdSync'
})(AdSync)
const selector = formValueSelector('AdSync')
AdSync = connect(state => {
    const hasCreateUser = selector(state, 'enable_create_user')
    const hasManagePassword = selector(state, 'enable_random_password_on_login')
    const ad_user_mgmt_config_id = selector(state, 'ad_user_mgmt_config_id')
    return {
        hasCreateUser,
        hasManagePassword,
        ad_user_mgmt_config_id
    }
})(AdSync)

export default function UpdateLdap(props) {
    const [currentTab, setCurrentTab] = useState('form');
    const { t } = useTranslation('common');

    const tabList = [
        { name: 'buttons.Edit', key: 'form' },
        { name: 'mapping.Attribute Mapping', key: 'attributemapping' },
        { name: 'auth.ad-sync', key: 'adsync' },
    ]
    const userData = {
        ldap_id: props.match.params.id
    }
    const onSuccess = () => {
        props.history.push('/ldap');
    }

    return (
        <div>
            <PageHeader location={props.location} routes={typeof newRoutes !== 'undefined' ? newRoutes : null} title={t('auth.update-ldap-configuration')} icon={<FontAwesomeIcon icon={faShieldKeyhole} />} />
            <Form
                {...props}
                tabList={tabList}
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
                userData={userData}
                section="auth"
                type="update"
                dispatchFunc={updateLdap}
                onSuccess={onSuccess}
                form={<LdapForm ldapId={props.match.params.id} />}
                tabs={
                    <React.Fragment>
                        <div className={(currentTab === 'attributemapping' ? 'tw-block' : 'tw-hidden')}>
                            <MappingTable sso_id={props.match.params.id} sso_type="LDAP" />
                        </div>
                        <div className={(currentTab === 'adsync' ? 'tw-block' : 'tw-hidden')}>
                            <AdSync {...props} />
                        </div>
                    </React.Fragment>
                }
            />
        </div>

    )
}
